import React from 'react'

import Appliances from '../../../components /ProductPage/ItemsProduct/productsAppliances'

const AppliancesPage = () => {
  return (
    <div>
      <Appliances />
    </div>
  )
}

export default AppliancesPage
